module.exports = __webpack_public_path__ + "static/media/logo.e91ee79d.png";